import React, { useEffect, useRef, useState } from 'react';
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import { Col, Collapse, Row } from 'reactstrap';
import withRouter from '../../Components/Common/withRouter';

// Import Data
import navdata from "../LayoutMenuData";
//i18n
import { withTranslation } from "react-i18next";
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { Skeleton, Stack } from '@mantine/core';


const isActive = (link, currentPath) => {
    if (!link || !currentPath) return false;
    const normalizePath = (str) => str.replace(/\/+$/, '') || '/';
    return normalizePath(currentPath) === normalizePath(link);
};

const isAnyChildActive = (subItems, currentPath) => {
    if (!subItems || !Array.isArray(subItems)) return false;
    return subItems.some(sub => 
        isActive(sub.link, currentPath) ||
        (sub.childItems && isAnyChildActive(sub.childItems, currentPath)) ||
        (sub.items && sub.items.some(item => isActive(item.link, currentPath)))
    );
};

const HorizontalLayout = (props) => {
    const selectorSettings = createSelector(
        state => state.Settings,
        result => ({
            requireInitRedirect: result.requireInitRedirect,
	        currentItemsMenu: result.currentItemsMenu || []
        })
    );

    const {
        requireInitRedirect,
        currentItemsMenu
    } = useSelector(selectorSettings);

	const userProfileData = createSelector(
        state => state.Profile,
        state => ({
            user: state.user,
            establishmentActive: state.establishmentActive,
        })
    );
	const { user, establishmentActive } = useSelector(userProfileData);

    const [isMoreMenu, setIsMoreMenu] = useState(false);
    const [openMenus, setOpenMenus] = useState({});
    const navData = currentItemsMenu;
    let menuItems = [];
    let splitMenuItems = [];
    let menuSplitContainer = 20;
    navData.forEach(function (value, key) {
        if (value['isHeader']) {
            menuSplitContainer++;
        }
        if (key >= menuSplitContainer) {
            let val = value;
            val.childItems = value.subItems;
            val.isChildItem = (value.subItems) ? true : false;
            delete val.subItems;
            splitMenuItems.push(val);
        } else {
            menuItems.push(value);
        }
    });

    const toggleSubMenu = (menuKey) => {
        setOpenMenus((prev) => ({
            ...prev, // Mantener el estado de los otros menús
            [menuKey]: !prev[menuKey], // Alternar el estado del menú seleccionado
        }));
    };
    

    const path = props.router.location.pathname;
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const initMenu = () => {
            const pathName = process.env.PUBLIC_URL + path;
            const ul = document.getElementById("navbar-nav");
            const items = ul.getElementsByTagName("span");
            let itemsArray = [...items]; // converts NodeList to Array
            removeActivation(itemsArray);
            let matchingMenuItem = itemsArray.find((x) => {
                return x.pathname === pathName;
            });
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        initMenu();
    }, [path, props.layoutType]);

    function activateParentDropdown(item) {
        item.classList.add("active");
        let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

        if (parentCollapseDiv) {

            // to set aria expand true remaining
            parentCollapseDiv.classList.add("show");
            parentCollapseDiv.parentElement.children[0].classList.add("active");
            parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                var parentElementDiv = parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling;
                if (parentElementDiv)
                    if (parentElementDiv.closest(".collapse"))
                        parentElementDiv.closest(".collapse").classList.add("show")
                parentElementDiv.classList.add("active");
                var parentElementSibling = parentElementDiv.parentElement.parentElement.parentElement.previousElementSibling;
                if (parentElementSibling) {
                    parentElementSibling.classList.add("active");
                }
            }
            return false;
        }
        return false;
    }

    const removeActivation = (items) => {
        let actiItems = items.filter((x) => x.classList.contains("active"));

        actiItems.forEach((item) => {
            if (item.classList.contains("menu-link")) {
                if (!item.classList.contains("active")) {
                    item.setAttribute("aria-expanded", false);
                }
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
            }
            if (item.classList.contains("nav-link")) {
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("active");
        });
    };



    return (
        <React.Fragment>
            {(menuItems.length) && !requireInitRedirect && establishmentActive ? (menuItems || []).map((item, key) => {

                let maxColumn = 0;
                if (item.subItems) {
                    item.subItems.forEach((column) => {
                        if (column.column > maxColumn) {
                            maxColumn = column.column;
                        }
                    })
                }

                const columnWidth = Math.floor(12 / maxColumn);

                const itemIsActive = isActive(item.link, path) || isAnyChildActive(item.subItems, path);

                return (
                    <React.Fragment key={key}>
                  
                        { !item['isHeader'] ?
                            (item.subItems ? (
                                <li className="nav-item"> 
                                    <span
                                        onClick={() => toggleSubMenu(item.id)}
                                        className={`nav-link menu-link${itemIsActive ? ' active-custom' : ''}`}
                                        to={item.link ? item.link : "/#"}
                                        // data-bs-toggle="collapse"
                                        style={{ cursor: "pointer" }} 
                                    >
                                        <i className={item.icon}></i> <span data-key="t-apps">{props.t(item.label)}</span>
                                    </span>
                                    <Collapse
                                        className={item.columns ? "menu-dropdown" : "menu-dropdown"}
                                        isOpen={!!openMenus[item.id]}
                                        style={{ ...(maxColumn > 1 && { width: `${maxColumn * 200}px` }) }}
                                        id="sidebarApps">
                                        {item.columns ? (
                                            <React.Fragment>
                                                <Row className='menu-dropdown-column'>
                                                    {Array.from({ length: maxColumn }, (_, index) => {
                                                        const columns = item.subItems.filter(item => item.column === index + 1);
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <Col lg={columnWidth}>
                                                                    {columns.length > 0 && (
                                                                        <div className='m-0 p-0'>
                                                                            {columns.map((column, columnIndex) => (
                                                                                <div key={columnIndex} className='m-0 p-0'>
                                                                                    {
                                                                                        column.subtitle ? (<h6>{column.subtitle}</h6>) : null
                                                                                    }
                                                                                    <ul className={`nav nav-sm flex-column ${!column.subtitle ? "without-subtitle" : ""}`}>
                                                                                        {column.items.map((subItem, subIndex) => {
                                                                                            const subItemIsActive = isActive(subItem.link, path);
                                                                                            return (
                                                                                                <li className="nav-item" key={subIndex}>
                                                                                                    <Link to={subItem.link ? subItem.link : "/#"} className={`nav-link ${column.subtitle ? "with-subtitle" : ""}${subItemIsActive ? ' active-custom' : ''}`}>{props.t(subItem.label)}</Link>
                                                                                                </li>
                                                                                            );
                                                                                        })}
                                                                                    </ul>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </Col>
                                                            </React.Fragment>
                                                        );
                                                    })}

                                                </Row>
                                            </React.Fragment>
                                        ) : (
                                            <ul className="nav nav-sm flex-column test">
                                                {item.subItems && ((item.subItems || []).map((subItem, key) => {
                                                    const subItemIsActive = isActive(subItem.link, path) || isAnyChildActive(subItem.childItems, path);
                                                    
                                                    return (
                                                        <React.Fragment key={key}>
                                                            {!subItem.isChildItem ? (
                                                                <li className="nav-item">
                                                                    <Link
                                                                        to={subItem.link ? subItem.link : "/#"}
                                                                        className={`nav-link${subItemIsActive ? ' active-custom' : ''}`}
                                                                    >
                                                                        {subItem.icon ? <i className={subItem.icon}></i> : null} {props.t(subItem.label)}
                                                                    </Link>
                                                                </li>
                                                            ) : (
                                                                <li className="nav-item">
                                                                    <span
                                                                        onClick={() => toggleSubMenu(subItem.id)}
                                                                        className={`nav-link${subItemIsActive ? ' active-custom' : ''}`}
                                                                        to="/#"
                                                                        data-bs-toggle="collapse"
                                                                        style={{ cursor: "pointer" }}
                                                                    > {subItem.icon ? <i className={subItem.icon}></i> : null} {props.t(subItem.label)}
                                                                    </span>
                                                                <Collapse className="menu-dropdown" isOpen={!!openMenus[subItem.id]} id="sidebarEcommerce">
                                                                    <ul className="nav nav-sm flex-column">
                                                                        {subItem.childItems && (
                                                                            (subItem.childItems || []).map((subChildItem, key) => {
                                                                                const childItemIsActive = isActive(subChildItem.link, path) || isAnyChildActive(subChildItem.childItems, path);
                                                                                
                                                                                return (
                                                                                    <React.Fragment key={key}>
                                                                                        {!subChildItem.isChildItem ? (
                                                                                            <li className="nav-item">
                                                                                                <Link
                                                                                                    to={subChildItem.link ? subChildItem.link : "/#"}
                                                                                                    className={`nav-link${childItemIsActive ? ' active-custom' : ''}`}
                                                                                                >
                                                                                                    {subChildItem.icon ? <i className={subChildItem.icon}></i> : null} {props.t(subChildItem.label)}
                                                                                                </Link>
                                                                                            </li>
                                                                                        ) : (
                                                                                            <li className="nav-item">
                                                                                                <span
                                                                                                    onClick={() => toggleSubMenu(subChildItem.id)}
                                                                                                    className={`nav-link${childItemIsActive ? ' active-custom' : ''}`}
                                                                                                    to="/#"
                                                                                                    data-bs-toggle="collapse"
                                                                                                >
                                                                                                    {subChildItem.icon ? <i className={subChildItem.icon}></i> : null} {props.t(subChildItem.label)}
                                                                                                </span>
                                                                                                <Collapse className="menu-dropdown" isOpen={!!openMenus[subChildItem.id]} id="sidebarEcommerce">
                                                                                                    <ul className="nav nav-sm flex-column">
                                                                                                        {subChildItem.childItems && (
                                                                                                            (subChildItem.childItems || []).map((subSubChildItem, key) => (
                                                                                                                <li className="nav-item apex" key={key}>
                                                                                                                    <Link
                                                                                                                        to={subSubChildItem.link ? subSubChildItem.link : "/#"}
                                                                                                                        className={`nav-link${isActive(subSubChildItem.link, path) ? ' active-custom' : ''}`}
                                                                                                                    >
                                                                                                                        {subSubChildItem.icon ? <i className={subSubChildItem.icon}></i> : null} {props.t(subSubChildItem.label)}
                                                                                                                    </Link>
                                                                                                                </li>
                                                                                                            ))
                                                                                                        )}
                                                                                                    </ul>
                                                                                                </Collapse>
                                                                                            </li>
                                                                                        )}
                                                                                    </React.Fragment>
                                                                                );
                                                                            })
                                                                        )}
                                                                    </ul>
                                                                </Collapse>
                                                            </li>
                                                        )}
                                                    </React.Fragment>
                                                );
                                                })
                                                )}
                                            </ul>
                                        )}
                                    </Collapse>
                                </li>
                            ) : (
                                <li className="nav-item">
                                    <Link
                                        className={`nav-link menu-link${itemIsActive ? ' active-custom' : ''}`}
                                        to={item.link ? item.link : "/#"}>
                                        <i className={item.icon}></i> <span>{props.t(item.label)}</span>
                                    </Link>
                                </li>
                            ))
                            : (<li className="menu-title"><span data-key="t-menu">{props.t(item.label)}</span></li>)}
                    </React.Fragment>
                );
            })
            : (
                <div className='w-100 nav-item px-3' style={{minHeight: '42px'}}>
                    <Row className='justify-content-center align-items-center h-100'>
                        {
                            Array.from({ length: 12 }, (_, index) => (
                                <div className="col" key={index}>
                                        <div className='col px-1'>
                                            <Skeleton width="100%" height={14} />
                                        </div>
                                </div>
                            ))
                        }
                    </Row>
                </div>
            )
        }
        </React.Fragment>
    );
};

HorizontalLayout.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withRouter(withTranslation()(HorizontalLayout));
